import { render, staticRenderFns } from "./NewIdea.vue?vue&type=template&id=567d08ba&"
import script from "./NewIdea.vue?vue&type=script&lang=js&"
export * from "./NewIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports